// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__TYTsN","inner":"Footer_inner__fpdz2","nextIcon":"Footer_nextIcon__H2Dzz","innerLeft":"Footer_innerLeft__1DpU8"};